define([], function () {

    $(document).ready(function() {

        $('.js-go-to-anchor').on('click', function(e) {
            e.preventDefault();

            let anchor = $(this).attr("href");

            $('html, body').animate({
                scrollTop: $(anchor).offset().top
            }, 300);
        });

    });

});
